// Curated Phosphor icon set exposed to the Navigation Builder. Icons are
// stored on the backend as the component name string ("Kanban") and mapped
// back to a real React component here. Add to this list whenever the Platform
// Admin wants a new icon option.
import {
  House, Users, Kanban, Package, ShoppingCart, Receipt, CurrencyInr,
  CheckSquare, Bell, CalendarBlank, ChartLine, Sparkle, UsersThree,
  Gear, ClockCounterClockwise, Shield, Trophy, PlugsConnected, Megaphone,
  Envelope, Phone, ChatCircle, ChatCircleDots, Star, Storefront, Truck,
  Warehouse, Wallet, Briefcase, Wrench, Palette, Buildings, Coins, Handshake,
  Question, Lightning, Rocket, Target, Tag, Ticket, Notepad,
  ClipboardText, Folder, FolderOpen, Cube, MapPin, IdentificationCard,
  Fire, Heart, Lifebuoy, ChartBar, ChartPieSlice,
  Cloud, Database, Robot, Broadcast, Gift, PaperPlaneTilt, Newspaper,
} from "@phosphor-icons/react";

export const ICONS = {
  House, Users, Kanban, Package, ShoppingCart, Receipt, CurrencyInr,
  CheckSquare, Bell, CalendarBlank, ChartLine, Sparkle, UsersThree,
  Gear, ClockCounterClockwise, Shield, Trophy, PlugsConnected, Megaphone,
  Envelope, Phone, ChatCircle, ChatCircleDots, Star, Storefront, Truck,
  Warehouse, Wallet, Briefcase, Wrench, Palette, Buildings, Coins, Handshake,
  Question, Lightning, Rocket, Target, Tag, Ticket, Notepad,
  ClipboardText, Folder, FolderOpen, Cube, MapPin, IdentificationCard,
  Fire, Heart, Lifebuoy, ChartBar, ChartPieSlice,
  Cloud, Database, Robot, Broadcast, Gift, PaperPlaneTilt, Newspaper,
};

/** Look up a Phosphor icon component by name. Falls back to House when the
 *  stored name is unknown (icon set version drift, typo, etc.). */
export function iconFor(name) {
  return ICONS[name] || House;
}

export const ICON_NAMES = Object.keys(ICONS).sort();
